module.exports = __webpack_public_path__ + "4.1.9/img/x2_3.1792e971.png";